import React from "react";

function HelpPage() {
    return (
        <div>Work in progress</div>
    );
}

export default HelpPage;
